













import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

@Component
export default class PoliciesDialogTab extends Vue {
  @Prop({ type: Number, default: 0 }) readonly value!: number

  model = 0

  items = ['Expiring today', 'Expiring in 30 days', 'Binding today', 'Effective today']

  mounted () {
    this.model = this.value
  }

  @Watch('value')
  onValueChanged () {
    this.model = this.value
  }

  @Emit('input')
  valueChangedHandler (index: number) {
    this.model = index
    return index
  }
}
